
import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import "./headerThemeCard.css";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  BellDot,
  MessageSquareText,
  ShoppingCart} from 'lucide-react';

const HeaderThemeCard =({cardType,themeText,fontFamily,bgColor,activeCardBorder,textIconBG,primaryColor,textIconPrimary,activeCard,onClickPopup})=>{

    
     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
     
      
      const activeCardBorderIn =activeCard?"4px solid #90CAF9":"4px solid #fff";
       const activeCardBorderStyle={border:activeCardBorderIn,padding:"0px",margin:"0px"}
      const bgColorStyle={background:bgColor,border:activeCardBorder,paddingTop:"10px",
          fontFamily:fontFamily,color:textIconBG
      }
      const textIconBGStyle={background:textIconBG,padding:"0px",margin:"0px"}
      const primaryColorStyle={background:primaryColor,border:activeCardBorder,paddingTop:"10px",
        fontFamily:fontFamily,color:textIconPrimary}
      const textIconPrimaryStyle={background:textIconPrimary,padding:"0px",margin:"0px"}
     
      return (<>
      {cardType==1? <div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()}  className="itemHeaderThemeCard"
 style={activeCardBorderStyle}> {activeCard?<div className="activeHeaderCardIcon"><Check size={20}  color={"#fff"} /></div>:""}
<div style={bgColorStyle} className="itemHeaderThemeCardInner">
<div></div>

<BellDot size={18}  color={textIconBG} />
<MessageSquareText size={18}  color={textIconBG} />
<ShoppingCart size={18}  color={textIconBG} />
</div>
<div style={{fontSize:"16px",fontWeight:"bold"}}>{themeText}</div>
 </div>
 :
 <div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()}  className="itemHeaderThemeCard"
 style={activeCardBorderStyle}> {activeCard?<div className="activeHeaderCardIcon"><Check size={20}  color={"#fff"} /></div>:""}
<div style={primaryColorStyle} className="itemHeaderThemeCardInner">
<div></div>
<BellDot size={18}  color={textIconPrimary} />
<MessageSquareText size={18}  color={textIconPrimary} />
<ShoppingCart size={18}  color={textIconPrimary} />
</div>
<div style={{fontSize:"16px",fontWeight:"bold"}}>{themeText}</div>
 </div>}</>)
}
export default HeaderThemeCard;

